<template>
    <Head title="Tableau de bord" />

    <AppLayout>
        <div class="grid grid-cols-6 gap-1 mb-4" v-if="$page.props.acl.isAdmin">
            <div class="flex flex-col col-span-full sm:col-span-1">
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-center mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-gray-200 mr-3">
                             <svg class="h-6 w-6" viewBox="0 0 24 24">
                                <path class="fill-current text-sky-300" d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z"/>
                                <path class="fill-current text-sky-dark" d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z"/>
                                <path class="fill-current text-sky" d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z"/>
                            </svg>
                        </div>
                        <h2 class="font-semibold text-sm text-sky">
                            {{ dashboard_views.trajetAvailable }}
                            Disponible{{ dashboard_views.trajetAvailable > 1 ? 's' : '' }}
                        </h2>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Expéditions</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">{{ dashboard_views.totalTrajet }}</div>
                    </div>
                </div>
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-start mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-yellow-500">
                            <svg class="w-8 h-8 fill-current text-white" viewBox="0 0 36 36">
                                <path d="M25 24H11a1 1 0 01-1-1v-5h2v4h12v-4h2v5a1 1 0 01-1 1zM14 13h8v2h-8z"></path>
                            </svg>
                        </div>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Total dù</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ formatAmount(dashboard_views.totalDu, currency) }}
                        </div>
                    </div>
                </div>
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-center mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-gray-200 mr-3">
                            <svg class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                                <path class="fill-current text-primaryOrange" fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd"></path>
                            </svg>
                        </div>
                        <h2 class="font-semibold text-sm text-greendack-500">
                            {{ dashboard_views.totalItemPaid }} Vendu{{ dashboard_views.totalItemPaid > 1 ? 's' : '' }}
                        </h2>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Total articles</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ dashboard_views.totalItem }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-full sm:col-span-1">
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-center mb-2">
                        <div class="flex justify-center items-center w-9 h-9 bg-gray-200 rounded-full shrink-0">
                            <svg class="w5 h-5 fill-current" viewBox="0 0 24 24">
                                <path class="text-red-300" d="M12 10l12 7-12 7-12-7z"></path>
                                <path class="text-red-500" d="M12 5l12 7-12 7-12-7z"></path>
                                <path class="text-red-700" d="M12 0l12 7-12 7L0 7z"></path>
                            </svg>
                        </div>
                        <h2 class="font-semibold text-sm text-red-500">
                            {{ dashboard_views.totalPackageTaked }}
                            Colis récupéré{{ dashboard_views.totalPackageTaked > 1 ? 's' :  '' }}
                        </h2>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Colis</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2"> {{ dashboard_views.totalPackage }}</div>
                    </div>
                </div>
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-start mb-2">
                        <div class="w-9 h-9 rounded-full shrink-0 bg-red-500 mr-3">
                            <svg class="w-9 h-9 fill-current text-white" viewBox="0 0 36 36">
                                <path d="M17.7 24.7l1.4-1.4-4.3-4.3H25v-2H14.8l4.3-4.3-1.4-1.4L11 18z"></path>
                            </svg>
                        </div>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Total dépensé</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ formatAmount(dashboard_views.totalSpent, currency) }}
                        </div>
                    </div>
                </div>
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-start mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-gray-200 mr-3">
                            <svg class="h-5 w-5" viewBox="0 0 24 24">
                                <path class="fill-current text-greendack" d="M18.974 8H22a2 2 0 012 2v6h-2v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-2v-6a2 2 0 012-2h.974zM20 7a2 2 0 11-.001-3.999A2 2 0 0120 7zM2.974 8H6a2 2 0 012 2v6H6v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5H0v-6a2 2 0 012-2h.974zM4 7a2 2 0 11-.001-3.999A2 2 0 014 7z"></path>
                                <path class="fill-current text-orange-400" d="M12 6a3 3 0 110-6 3 3 0 010 6zm2 18h-4a1 1 0 01-1-1v-6H6v-6a3 3 0 013-3h6a3 3 0 013 3v6h-3v6a1 1 0 01-1 1z"></path>
                            </svg>
                        </div>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Total Clients</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ dashboard_views.totalCustomer }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-full sm:col-span-1">          
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-start mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-greendack-500">
                            <svg class="w-4 h-4 shrink-0 fill-current text-white" viewBox="0 0 16 16">
                                <path d="M15 4c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H3c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3h7c.6 0 1 .4 1 1v3h4zM2 3v1h7V2H3c-.6 0-1 .4-1 1zm12 11V6H2v7c0 .6.4 1 1 1h11zm-3-5h2v2h-2V9z"></path>
                            </svg>
                        </div>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-400">Total encaissé</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ formatAmount(dashboard_views.totalPaid, currency) }}
                        </div>
                    </div>
                </div>    
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-center mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-greendack-500">
                            <svg class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <h2 class="font-semibold text-sky-500 text-sm">
                            Pénalités: {{ formatAmount(dashboard_views.totalPenalties, currency) }}
                        </h2>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-500">Total bénéfices</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ formatAmount(dashboard_views.totalProfit, currency) }}
                        </div>
                    </div>
                </div>
                <div class="p-4 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header class="flex justify-between items-center mb-2">
                        <div class="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-gray-200 mr-3">
                            <svg class="h-6 w-6" viewBox="0 0 24 24">
                                <path class="fill-current text-sky" d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z"></path>
                                <path class="fill-current text-sky-300" d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z"></path>
                            </svg>
                        </div>
                        <h2 class="font-semibold text-sm text-sky-500">
                            {{ dashboard_views.requestPending }} En attente
                        </h2>
                    </header>
                    <h2 class="text-lg font-semibold text-gray-500">Total demandes</h2>
                    <div class="flex items-start">
                        <div class="text-xl font-bold text-gray-800 mr-2">
                            {{ dashboard_views.totalRequest }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-full sm:col-span-3">
                <div class="pt-2 mt-2 bg-white shadow-lg rounded-sm border border-gray-200">
                    <h2 class="text-lg font-semibold text-gray-400 text-center">Statistiques</h2>
                    <div class="grow flex flex-col justify-center">
                        <Doughnut :chart-data="chartData" :chart-options="chartOptions" :labels="labels" style="height:383px !important" />
                    </div>
                </div>
            </div>
        </div>
        <div x-data="handleSelect">
            <Datatables v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial">
                <template #title>
                    Demandes d'envoi de colis en attente
                    <span class="font-medium">({{ dashboard_views.recentRequests.length }})</span>
                </template>
    
                <template #tableHeader>
                    <th class="lg:hidden">#</th>
                    <th>Code</th>
                    <th>Demandeur</th>
                    <th>Envoyé le</th>
                    <th># Colis</th>
                    <th>Statut</th>
                    <th><span class="sr-only">Menu</span></th>
                </template>
    
                <template #tableBody>
                    <tr v-for="(req, index) in dashboard_views.recentRequests" :key="index">
                        <td class="lg:hidden">{{ index + 1 }}</td>
                        <td>{{ req.code }}</td>
                        <td>
                            <div class="flex items-center">
                                <div class="w-8 h-8 shrink-0 flex items-center justify-center rounded-full mr-2"
                                    :class="req.user ? 'bg-gray-500' : 'bg-primaryOrange-100'"
                                >
                                    <img class="rounded-full border-2 box-content" :class="req.user ? 'border-white' : ''"
                                        :src="req.user ? req.user.profile_photo_url : '/images/new.png'" width="32" height="32"
                                    />
                                </div>
    
                                <div class="grow text-left">
                                    <h2 class="font-semibold inline-flex" :class="req.user ? 'text-sky-500' : 'text-gray-500'">
                                        {{ req.user ? req.user.name : req.requester_name }}
                                    </h2>
                                    <div class="text-xs text-gray-400 font-semibold">
                                        {{ req.user ? req.user.full_phone : (req.full_phone || 'Numéro non défini') }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="capitalize">{{ formattedDateTime(req.created_at) }}</td>
                        <td>{{ req.weight_package ? req.weight_package : 'Non défini' }}</td>
                        <td><StatusBadge :label="req.status_text" :color="req.status_color" /></td>
                        <td>
                            <Link class="flex justify-end" :href="route('travels.requests', req.travel) + '?filter[code]=' + req.code" title="Détails">
                                <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                    <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                    <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                </svg>
                            </Link>
                        </td>
                    </tr>
                </template>
            </Datatables>
        </div>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Doughnut } from 'vue-chartjs'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Datatables from '@/Components/Datatables'
    import StatusBadge from '@/Components/StatusBadge'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import DateFormatMixins from '@/Mixins/DateFormatMixins'
    import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'

    // Import TailwindCSS variables
    import resolveConfig from 'tailwindcss/resolveConfig'
    import tailwindConfig from '../../../tailwind.config'

    // Tailwind config
    const fullConfig = resolveConfig(tailwindConfig)

    ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

    export default defineComponent({
        components: {
            Head,
            Link,
            Doughnut,
            AppLayout,
            Datatables,
            StatusBadge
        },

        props: {
            dashboard_views: Object,
            currency: Object,
        },

        mixins: [CurrencyMixins, DateFormatMixins],

        setup(props) {
            const chartData = {
                labels: ['Dépenses', 'Encaissé', 'Restant'],
                datasets: [
                    {
                        data: [
                            props.dashboard_views.totalSpent,
                            props.dashboard_views.totalPaid,
                            props.dashboard_views.totalDu
                        ],
                        backgroundColor: [
                            fullConfig.theme.colors.red[500],
                            fullConfig.theme.colors.green[400],
                            fullConfig.theme.colors.yellow[500]
                        ],
                        hoverBackgroundColor: [
                            fullConfig.theme.colors.red[600],
                            fullConfig.theme.colors.green[500],
                            fullConfig.theme.colors.yellow[600]
                        ],
                        hoverBorderColor: fullConfig.theme.colors.white
                    }
                ]
            }

            const chartOptions =  {
                cutout: '80%',
                layout: {
                    padding: 24
                },
                interaction: {
                    intersect: false,
                    mode: 'nearest'
                },
                animation: {
                    duration: 200,
                },
                maintainAspectRatio: false
            }

            return {
                chartData,
                chartOptions
            }
        },
    })
</script>
